import { Provider } from "@angular/core";
import {
    ATOM_SELECT_PANEL_CONFIG,
    ATOM_SELECT_PANEL_DEFAULT_CONFIG,
    AtomSelectPanelConfig,
} from "@atomchat-io/ui-design-system";
import { translateSignal } from "@jsverse/transloco";

const BASE_KEY_PATH = "atom_select_panel";

/**
 * Bridges `ATOM_SELECT_PANEL_CONFIG` to Transloco.
 *
 * Spreads {@link ATOM_SELECT_PANEL_DEFAULT_CONFIG} and overrides only the
 * localized copy. Fields typed `AtomSelectPanelText` take `translateSignal()`
 * directly so panels repaint on live language switches
 * (`reRenderOnLangChange: true`).
 *
 * Filter-specific copy (category title, counter, clear labels) lives on
 * {@link AtomFilterPanelConfigService} via `AtomFilterPanelIntl`, not here.
 */
export const provideAtomSelectPanelConfig = (): Provider => ({
    provide: ATOM_SELECT_PANEL_CONFIG,
    useFactory: (): AtomSelectPanelConfig => ({
        ...ATOM_SELECT_PANEL_DEFAULT_CONFIG,
        searchPlaceholder: translateSignal(
            `${BASE_KEY_PATH}.search_placeholder`,
        ),
        emptyStateTitle: translateSignal(`${BASE_KEY_PATH}.empty_state_title`),
        emptyStateDescription: translateSignal(
            `${BASE_KEY_PATH}.empty_state_description`,
        ),
        loadingCaption: translateSignal("atom_select_input.loading_caption"),
        footerActionLabel: translateSignal(
            `${BASE_KEY_PATH}.footer_action_label`,
        ),
        selectAllLabel: translateSignal(`${BASE_KEY_PATH}.select_all_label`),
        deselectAllLabel: translateSignal(
            `${BASE_KEY_PATH}.deselect_all_label`,
        ),
    }),
});
